import script from "./Identicons.vue?vue&type=script&setup=true&lang=ts"
export * from "./Identicons.vue?vue&type=script&setup=true&lang=ts"

import "./Identicons.vue?vue&type=style&index=0&id=6766dc5a&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6766dc5a"]])

export default __exports__